export const ADD_TO_CART = 'ADD_TO_CART';
export const ADD_CONFIGURATION_TO_CART = 'ADD_CONFIGURATION_TO_CART';
export const REMOVE_FROM_CART = 'REMOVE_FROM_CARD';
export const STRIP_FROM_CART = 'STRIP_FROM_CART';
export const CHECKOUT_REQUEST = 'CHECKOUT_REQUEST';
export const CHECKOUT_FAILURE = 'CHECKOUT_FAILURE';
export const ADD_TO_CONFIGURATION = 'ADD_TO_CONFIGURATION';
export const RECEIVE_PRODUCTS = 'RECEIVE_PRODUCTS';
export const REMOVE_FROM_CONFIGURATION = 'REMOVE_FROM_CONFIGURATION';
